import React from 'react';
import { Bot, CheckCircle, XCircle } from 'lucide-react';

const AdminTezzaTab = ({ 
  tezzaActivity, 
  tezzaStats,
  formatDate 
}) => {
  return (
    <div className="admin-card full-width" data-testid="tezza-tab">
      <h2><Bot className="h-5 w-5" /> Tezza AI Agent Activity</h2>
      
      {/* Tezza Stats */}
      {tezzaStats && (
        <div className="tezza-stats" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '16px',
          marginBottom: '24px'
        }}>
          <div style={{
            background: '#f0fdf4',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#22c55e' }}>
              {tezzaStats.successful_links_sent}
            </div>
            <div style={{ fontSize: '13px', color: '#166534' }}>Fresh Links Sent</div>
          </div>
          <div style={{
            background: '#eff6ff',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#3b82f6' }}>
              {tezzaStats.total_verifications}
            </div>
            <div style={{ fontSize: '13px', color: '#1e40af' }}>Verification Attempts</div>
          </div>
          <div style={{
            background: '#fef2f2',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#ef4444' }}>
              {tezzaStats.failed_attempts}
            </div>
            <div style={{ fontSize: '13px', color: '#991b1b' }}>No Payment Found</div>
          </div>
        </div>
      )}
      
      {tezzaActivity.length > 0 ? (
        <div className="tezza-activity-list">
          {tezzaActivity.map((activity) => (
            <div key={activity._id || `${activity.email}-${activity.created_at}`} className="tezza-activity-item" style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              borderBottom: '1px solid rgba(255,255,255,0.1)',
              background: activity.success ? 'rgba(34, 197, 94, 0.05)' : 'rgba(239, 68, 68, 0.05)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {activity.success ? (
                  <CheckCircle className="h-5 w-5" style={{ color: '#22c55e' }} />
                ) : (
                  <XCircle className="h-5 w-5" style={{ color: '#ef4444' }} />
                )}
                <div>
                  <div style={{ fontWeight: '500', color: '#e8f4f8' }}>
                    {activity.email}
                  </div>
                  <div style={{ fontSize: '12px', color: '#7a9db5' }}>
                    {activity.action === 'send_fresh_link' ? 'Fresh link sent' : 
                     activity.reason === 'no_payment_found' ? 'No payment found' :
                     activity.reason === 'invalid_email_format' ? 'Invalid email' :
                     activity.reason || activity.action}
                    {activity.amount && ` • $${activity.amount} AUD`}
                  </div>
                </div>
              </div>
              <div style={{ fontSize: '12px', color: '#666' }}>
                {formatDate(activity.created_at)}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="admin-empty">
          <Bot className="h-12 w-12" />
          <p>No Tezza activity yet.</p>
          <p style={{ fontSize: '13px', color: '#666' }}>
            When customers ask Tezza about payment issues, their verifications and sent links will appear here.
          </p>
        </div>
      )}
    </div>
  );
};

export default AdminTezzaTab;
